module.exports = __webpack_public_path__ + "img/badge-resident-brightbg.e0714f74.svg";